import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { Dispatch, SetStateAction } from 'react';

export const Nav4CollapseReminderSpotlightLoader: LoadableType<{
	setIsNav4CollapseReminderSpotlightActive: Dispatch<SetStateAction<boolean>>;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-Nav4ChangeboardingSpotlight" */ '../src/Nav4CollapseReminderSpotlight.tsx'
			)
		).Nav4CollapseReminderSpotlight,
});

export { useHasDismissedNav4CollapseReminderSpotlight } from '../src/useHasDismissedNav4CollapseReminderSpotlight.ts';
